import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import RestManager from "../business/RestManager";
import GigyaManager from "../business/GigyaManager";
import Constants from "../business/Constants";

class CompletaDatiCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.alphanumReg = /^[A-Za-z0-9 ']+$/;
        this.numberReg =  /^[0-9]+$/;
        this.capReg =  /\b\d{5}\b/;
        this.centReg =  /^[0-9]{2}$/;
        this.files = [];
        this.init();
    }
    init() {
        this.loadChildComponents(this);
        this.startLoader();
        let play_mode = this.getUrlParameter('pm');
        if ( play_mode == "1"){
            $('.playmode_1').remove();
        }
        GigyaManager.getLoggedUserCached().then((u) => {
            $('#email').val(u.profile.email);
            this.removeLoader();
        }, (err) => {
            window.location.href = "/login?urlBack="+window.location.href.replace(window.location.origin, "")+"&regSource="+Constants.PROMO_CODE;
        });

        //IMAGE VIEW
        $('#foto-scontrino').change(() => {
            var input =  $('#foto-scontrino')[0];
            let file = input.files[0];
            var maxSize = $(input).data('max-size');


            if (maxSize > file.size) {
                this.startLoader();
                RestManager.uploadImage(this.files.length == 0 ? 'front' : 'back', file).then((data)=>{
                    let filename_server = data.response.data.name;
                    let idx_file = filename_server.split(".")[0];
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        if (filename_server.match(/pdf$/)) {
                            $('.file-list').append('<div class="row" id="'+idx_file+'"><div class="figure"><img' +
                                ' src="/fe-web/img/icons/avatar_placeholder.jpg"></div><div' +
                                ' class="file-name">' + file.name + '</div><div class="delete-file" component-click="removeFile(\''+idx_file+'\')"></div></div>');
                        } else {
                            $('.file-list').append('<div class="row" id="'+idx_file+'"><div class="figure"><img src="' + e.target.result + '"></div><div class="file-name">' + file.name + '</div><div class="delete-file" component-click="removeFile(\''+idx_file+'\')"></div></div>');
                        }

                    }
                    reader.readAsDataURL(file);
                    this.files.push(filename_server);
                    if(this.files.length == 2){
                        $('#foto-scontrino').prop("disabled", true);
                        $('.carica-scontrino').addClass('disabled');
                    }
                    this.removeLoader();
                }, (resp) => {
                    this.removeLoader();
                })
            }else{
                $('#foto-scontrino').addClass('error');
                $('.custom-row--middle').append('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il file caricato è troppo grande</span>');
            }

        });

    }


    submit(){
        this.startLoader();
        this.validateForm();
    }
    sendForm(){
        let inputs = $('.col-form > input');
        let form = {
            play_token: this.getUrlParameter('pt')
        };
        for(let i = 0; i < inputs.length; i++){
            let input = $(inputs[i]);
            if(input.attr("id") != "foto-scontrino"){
                form[input.attr('name')] = input.val();
            }
        }

        if(this.getUrlParameter('pm') == "3"){
            form['receipt_product_code'] = $('#product').val();
            form['store'] = $('#market').val();
            form['receipt_file_front'] = this.files[0];
            if(this.files.length > 1){
                form['receipt_file_back'] = this.files[1];
            }
        }


        RestManager.prizeRequest(form).then((resp)=>{
            window.location.href = "/promozioni/vinci-il-buongiorno/thank-you";
        }, (err)=>{
            this.removeLoader();
            let tmplModalGeneric = ` <div class="feedback__modal" component="FeedbackModalComponent">
                                                    <div class="feedback__modal__wrap">
                                                        <div class="feedback__modal__close" component-click="close()">
                                                            <svg>
                                                                <use xlink:href="#svg_circle_close"></use>
                                                            </svg>
                                                        </div>
                                                        <div class="feedback__modal__content">
                                                            <h2 class="h3">Ops, qualcosa è andato storto! </h2>
                                                            <p>${err.status.errors.description}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                               `;
            $(this.element).append(tmplModalGeneric);
            this.loadChildComponents(this);
        });
    }
    getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    removeFile(idx){
        $('#'+idx).remove();
        for(let i = 0; i < this.files.length; i++ ){
            if(this.files[i].indexOf(idx) != -1){
                this.files.splice(i, 1);
            }
        }
        if(this.files.length == 2){
            $('#foto-scontrino').prop("disabled", true);
            $('.carica-scontrino').addClass('disabled');
        }else{
            $('#foto-scontrino').prop("disabled", false);
            $('.carica-scontrino').removeClass('disabled');
        }
    }

    removeLoader(){
        $('.tool_loader').fadeOut(500).remove();
        $('body').removeClass('noScroll');
        $('#conferma').prop("disabled", false).removeClass('disabled');
    }

    startLoader(){
        $('.mb-promo-fette-2019').append('<div data-tool-loader="" class="tool_loader"><svg><use xlink:href="#svg_loader"></use></svg></div>');
        $('body').addClass('noScroll');
        $('#conferma').prop("disabled", true).addClass('disabled');
    }

    validateForm(){

        $('.error-feedback').remove();
        $('input, select').removeClass('error');

        var varNome = this.take_nome();
        var varCognome = this.take_cognome();
        var varTelefono = this.take_telefono();
        var varCap = this.take_cap();
        var varIndirizzo = this.take_indirizzo();
        var varCivico = this.take_ncivico();
        var varCitta = this.take_citta();
        var varProvincia = this.take_provincia();

        var varStore = this.take_market();
        var varReceipt_product_code = this.take_product();

        var varFiles = this.files.length > 0;

        if(!varFiles){
            $('#foto-scontrino').addClass('error');
            $('.custom-row--middle').append('<span class="error-feedback"><span' +
                ' class="icon-error">!</span> Devi caricare almeno una foto dello scontrino!</span>');
        }


        if(varNome && varCognome && varTelefono && varCap && varIndirizzo && varCivico && varCitta && varProvincia && varStore && varReceipt_product_code) {
            this.sendForm();
        } else {
            this.removeLoader();
            return false;
        }

    }

    take_market(){
        if( $('#market').length ){
            var market = $('#market').val();
            if (market.length < 2 & market !== undefined){
                $('#market').addClass('error');
                $('.row-form--market').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_product(){
        if( $('#product').length ){
            var product = $('#product').val();
            if (product.length < 2 & market !== undefined){
                $('#product').addClass('error');
                $('.row-form--product').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>');
            } else {
                var productArr = [ '2029000290', '2029000295', '2029000296', '2029000168', '2029004479', '9991000009', '2010119001' ];
                if (productArr.indexOf(product) >= 0){
                    return true;
                } else {
                    $('#product').addClass('error');
                    $('.row-form--product').append('<span class="error-feedback"><span class="icon-error">!</span> Il campo deve essere selezionato</span>');
                }
            }
        } else {
            return true;
        }
    }


    take_nome(){
        if( $('#nome').length ){
            var nome = $('#nome').val();
            if (nome.length < 2 & nome !== undefined) {
                $('#nome').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                var validName = this.alphanumReg.test(nome);
                if (!validName) {
                    $('#nome').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto solo da' +
                        ' caratteri alfanumerici</span>');
                } else {
                    return true;
                }
            }
        } else {
            return true;
        }
    }

    take_cognome(){
        if( $('#cognome').length ){
            var cognome = $('#cognome').val();
            if (cognome.length < 2 & cognome !== undefined) {
                $('#cognome').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                var validCognome = this.alphanumReg.test(cognome);
                if (!validCognome) {
                    $('#cognome').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto solo da' +
                        ' caratteri alfanumerici</span>');
                } else {
                    return true;
                }
            }
        } else {
            return true;
        }
    }

    take_telefono(){
        if( $('#telefono').length ){
            var telefono = $('#telefono').val();
            if (telefono.length < 2 & telefono !== undefined) {
                $('#telefono').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                var validTel = this.numberReg.test(telefono);
                if (!validTel) {
                    $('#telefono').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto' +
                        ' solo da' +
                        ' caratteri numerici</span>');
                }
                return true;
            }
        } else {
            return true;
        }
    }

    take_cap(){
        if( $('#cap').length ){
            var cap = $('#cap').val();
            if (cap.length < 2 & cap !== undefined) {
                $('#cap').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                var validCap = this.capReg.test(cap);
                if (!validCap) {
                    $('#cap').addClass('error').after('<span class="error-feedback"><span' +
                        ' class="icon-error">!</span> Il campo deve essere composto' +
                        ' da ' +
                        '5 caratteri numerici</span>');
                } else {
                    return true;
                }
            }
        } else {
            return true;
        }
    }

    take_ncivico(){
        if( $('#ncivico').length ){
            var ncivico = $('#ncivico').val();
            if (ncivico.length < 1 & ncivico !== undefined) {
                $('#ncivico').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_indirizzo(){
        if( $('#indirizzo').length ){
            var indirizzo = $('#indirizzo').val();
            if (indirizzo.length < 2 & indirizzo !== undefined) {
                $('#indirizzo').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_citta(){
        if( $('#citta').length ){
            var citta = $('#citta').val();
            if (citta.length < 2 & citta !== undefined) {
                $('#citta').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    take_provincia(){
        if( $('#provincia').length ){
            var provincia = $('#provincia').val();
            if (provincia.length < 2 & provincia !== undefined) {
                $('#provincia').addClass('error').after('<span class="error-feedback"><span' +
                    ' class="icon-error">!</span> Il campo deve essere compilato</span>');
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

}

export default CompletaDatiCtrl;
